export default "<app-user-form (onsubmit)=\"save($event)\" [user]=\"user\"></app-user-form>";